<template>
  <v-container fluid>
    <v-row justify="center" align="center">
      <v-col cols="12" align="right">
        <v-btn color="primary" align="right" @click="add()" v-if="hasPermissions('Create promotion')"> Thêm </v-btn>
      </v-col>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="packages"
          :items-per-page="10"
          class="elevation-1"
        >
          <template v-slot:item.start_date="{ item }">
            <span>{{ formatDate(item.start_date) }}</span>
          </template>
          <template v-slot:item.end_date="{ item }">
            <span>{{ formatDate(item.end_date) }}</span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editItem(item.id)" v-if="hasPermissions('Update promotion')">
              mdi-pencil
            </v-icon>
            <!--              <v-icon small class="mr-2" @click="reviewItem(item.id)">-->
            <!--                mdi-eye-->
            <!--              </v-icon>-->
            <v-icon small @click="deleteItem(item.id)" v-if="hasPermissions('Delete promotion')"> mdi-delete </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import {
  GET_LIST_PACKAGES,
  DELETE_PACKAGES,
} from "@/store/modules/promotion_gift";

export default {
  data() {
    return {
      headers: [
        { text: "STT", value: "id" },
        { text: "Tên", value: "name" },
        { text: "Ngày bắt đầu", value: "start_date" },
        { text: "Ngày kết thúc", value: "end_date" },
        { text: "Actions", value: "actions" },
        { text: "", value: "active" },
      ],
    };
  },
  watch: {},
  computed: {
    ...mapGetters({
      packages: "packages",
      //   promotionDetail: "promotionDetail",
      //   banner: 'banner',
      //   categories: 'categories',
      //   brands: 'brands',
      //   tags: 'tags',
    }),
  },
  async created() {
    await this.$store.dispatch(`${GET_LIST_PACKAGES}`);
    // await this.$store.commit(`${SET_DETAIL_BANNER}`,{});
  },
  methods: {
    editItem(item) {
      this.$router.push(
        "/manage_promotion_gift/Manage_gift/edit_gift_wrap/" + item
      );
    },
    formatDate(date) {
      if (!date) return null;
      let newDate = new Date(date);
      const [year, month, day] = [
        newDate.getFullYear(),
        newDate.getMonth() + 1,
        newDate.getDate(),
      ];
      let day_format = day > 9 ? day : `0${day}`;
      let month_format = month > 9 ? month : `0${month}`;

      return `${day_format}/${month_format}/${year}`;
    },
    async add() {
      this.$router.push("/manage_promotion_gift/Manage_gift/add_gift_wrap");
    },
    async deleteItem(id) {
      const _this = this;
      confirm("Bạn có chắc muốn xóa?") &&
        (await this.$store.dispatch(`${DELETE_PACKAGES}`, id).then((data) => {
          if (data && data.status === 1) {
            _this.$store.dispatch(`${GET_LIST_PACKAGES}`);
          }
        }));
    },
  },
};
</script>